import { render, staticRenderFns } from "./FacturaInvalida.vue?vue&type=template&id=063259ab"
import script from "./FacturaInvalida.vue?vue&type=script&lang=js"
export * from "./FacturaInvalida.vue?vue&type=script&lang=js"
import style0 from "./FacturaInvalida.vue?vue&type=style&index=0&id=063259ab&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports